<template><section><h2>雷达图</h2>
<h3>attrs</h3>
<p>attrs 包含若干属性，可以初始化图表的时候对图表进行配置</p>
<table>
<thead>
<tr>
<th>属性</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>gridType</td>
<td>网格的类型，可选值为'polygon'和'circle'</td>
<td>String</td>
<td>polygon</td>
</tr>
<tr>
<td>splitNumber</td>
<td>背景网格的层数</td>
<td>Number</td>
<td>4</td>
</tr>
<tr>
<td>startAngle</td>
<td>坐标轴的起始角度</td>
<td>Number</td>
<td>270</td>
</tr>
<tr>
<td>radius</td>
<td>雷达图的轴长,范围[0,1]</td>
<td>Number</td>
<td>0.6</td>
</tr>
<tr>
<td>labelOffset</td>
<td>雷达图轴标记偏移量</td>
<td>Number</td>
<td>6</td>
</tr>
</tbody>
</table>
<h3>可配置 Style 名称</h3>
<pre v-pre><code v-pre class="language-js"><span class="hljs-keyword">const</span> radar = <span class="hljs-keyword">new</span> Radar()
radar.style(<span class="hljs-string">'point'</span>, { <span class="hljs-attr">size</span>: <span class="hljs-number">5</span> })
<span class="hljs-comment">// 或者函数模式</span>
radar.style(<span class="hljs-string">'point'</span>,(attr,data,i)=&gt;{<span class="hljs-keyword">return</span> {<span class="hljs-attr">size</span>:<span class="hljs-number">5</span>}})
</code></pre>
<p>style 方式支持链式调用，第一个参数为 style 名称，第二个参数为设置的样式 Object，也可以为函数形式，对样式进行详细设置</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基础类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>section</td>
<td>面</td>
<td>雷达图数据区样式</td>
</tr>
<tr>
<td>section:hover</td>
<td>面</td>
<td>雷达图数据区 hover 样式</td>
</tr>
<tr>
<td>point</td>
<td>面，除了基础面的全部属性外，还有(<a style="text-decoration:underline" href="./#/doc/plugin/Point">Point</a>)的特殊属性</td>
<td>雷达图数据区域的点的样式</td>
</tr>
<tr>
<td>axis</td>
<td>线</td>
<td>坐标轴的样式</td>
</tr>
<tr>
<td>grid</td>
<td>线</td>
<td>雷达图背景网格样式</td>
</tr>
<tr>
<td>label</td>
<td>文本</td>
<td>类别指示文字的样式(x 轴)</td>
</tr>
<tr>
<td>scale</td>
<td>文本</td>
<td>数值指示文字,(y 轴)</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>